export default __webpack_public_path__ + "static/media/vip12.ad979b58.webp";